"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FocusManagerContainer_1 = require("./FocusManagerContainer");
Object.defineProperty(exports, "FocusManagerContainer", { enumerable: true, get: function () { return FocusManagerContainer_1.FocusManagerContainer; } });
//# sourceMappingURL=index.js.map